import { Box, VStack, Text, Button, Icon } from "@chakra-ui/react";
import { MdInbox } from "react-icons/md"; // example icon
import { useNavigate } from "react-router-dom";
import ButtonC from "../../theme/ButtonC";
export default function EmptyState({
  title = "Nothing Here",
  description = "There’s currently no data to display.",
  buttonText,
  onButtonClick,
  icon = MdInbox,
}) {
  const navigate = useNavigate();

  return (
    <Box
      w="full"
      py={12}
      px={6}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <VStack spacing={4} textAlign="center">
        <Icon as={icon} boxSize={16} color="gray.400" />
        <Text fontWeight="bold" fontSize="xl">
          {title}
        </Text>
        <Text fontSize="sm" color="gray.600" maxW="md">
          {description}
        </Text>
        {buttonText && (
          <ButtonC 
            
            label={buttonText}
            bg="var(--cr-red-logo)"
            w={"full"}
            onClick={onButtonClick || (() => navigate("/"))}
          >
            {buttonText}
          </ButtonC>
        )}
      </VStack>
    </Box>
  );
}
